import clsx from 'clsx';

interface Props {
  chainId: number;
  size?: 28 | 36 | 44;
  className?: string;
}

/**
 * Inline-SVG chain logo. Self-contained (no external assets) so the
 * webapp ships in one bundle with no extra HTTP roundtrips. Each
 * brand is approximated to fit the editorial tone — recognisable
 * silhouette + the official brand colour, simplified.
 */
export function NetworkBadge({ chainId, size = 36, className }: Props) {
  const s = String(size);
  if (chainId === 137) {
    return (
      <svg
        width={s}
        height={s}
        viewBox="0 0 44 44"
        aria-hidden
        className={clsx('shrink-0', className)}
      >
        <rect width="44" height="44" rx="12" fill="#7C5CFF" />
        <path
          d="m13 16 6-3.4 6 3.4v6.7l-6 3.4-6-3.4V16Zm12.5 4 5.5-3.1V23.6l-5.5 3.1-5.5-3.1v-2L25 19.4v3.7l5.5-3.1Z"
          fill="#fff"
        />
      </svg>
    );
  }
  if (chainId === 56) {
    return (
      <svg
        width={s}
        height={s}
        viewBox="0 0 44 44"
        aria-hidden
        className={clsx('shrink-0', className)}
      >
        <rect width="44" height="44" rx="12" fill="#F0B90B" />
        <path
          d="m22 11 4.4 4.4-2 2-2.4-2.4-2.4 2.4-2-2L22 11Zm-9 9 2-2 2 2-2 2-2-2Zm5 2 4-4 4 4 4-4 2 2-6 6-4-4-4 4-2-2 2-2Zm9-2 2-2 2 2-2 2-2-2Zm-5 7 2.4-2.4 2.4 2.4-4.4 4.4-4.4-4.4 2-2 2.4 2.4Z"
          fill="#0F1320"
        />
      </svg>
    );
  }
  if (chainId === 1) {
    return (
      <svg
        width={s}
        height={s}
        viewBox="0 0 44 44"
        aria-hidden
        className={clsx('shrink-0', className)}
      >
        <rect width="44" height="44" rx="12" fill="#627EEA" />
        <path d="M22 8v10.6l9 4-9-14.6Z" fill="#fff" fillOpacity=".6" />
        <path d="M22 8 13 22.6l9-4V8Z" fill="#fff" />
        <path d="M22 28v8l9-12.5-9 4.5Z" fill="#fff" fillOpacity=".6" />
        <path d="M22 36v-8l-9-4.5L22 36Z" fill="#fff" />
      </svg>
    );
  }
  if (chainId === 42161) {
    // Arbitrum One — deep-navy background with the cyan-and-white
    // "A" chevron the brand book uses on dark surfaces.
    return (
      <svg
        width={s}
        height={s}
        viewBox="0 0 44 44"
        aria-hidden
        className={clsx('shrink-0', className)}
      >
        <rect width="44" height="44" rx="12" fill="#213147" />
        <path d="M22 11 11 33h5l3-6h6l3 6h5L22 11Zm-2 12 2-5 2 5h-4Z" fill="#28A0F0" />
        <path d="M27 27 22 17l5 10Z" fill="#fff" fillOpacity=".7" />
      </svg>
    );
  }
  return (
    <div
      style={{ width: size, height: size }}
      className={clsx('shrink-0 rounded-pb-md bg-pb-paper2', className)}
      aria-hidden
    />
  );
}
